<template>
  <DumplingBody />
</template>

<script>
import DumplingBody from '../molecules/DumplingBody.vue'


export default {
  name: 'DumplingView',
  components: {
    DumplingBody,
  }
}
</script>
